<form class="user-form" #form="ngForm" (ngSubmit)="onNext()">
  <mat-card [attr.aria-busy]="!langReady.ready()">
    <mat-card-header>
      <div class="mcf-logo">
        <img src="images/bib.png" alt="Bib" />
      </div>
      <div class="text">
        <app-lang-gate>
          <ng-container skeleton>
            <app-text-skeleton width="140px" />
            <app-text-skeleton width="240px" height="1.5em" />
          </ng-container>
          <mat-card-subtitle>{{
            'FORM_RE_REGISTRATION.HEADER.SUBTITLE' | translate
          }}</mat-card-subtitle>
          <mat-card-title>{{ 'FORM_RE_REGISTRATION.HEADER.TITLE' | translate }}</mat-card-title>
        </app-lang-gate>
      </div>
    </mat-card-header>

    <mat-card-content>
        <div class="info">
          <app-lang-gate>
            <ng-container skeleton>
              <app-text-skeleton />
              <app-text-skeleton width="90%" />
              <app-text-skeleton width="70%" />
            </ng-container>
            <p>
              <strong>{{ 'FORM_RE_REGISTRATION.INFO.BOLD_TEXT_1' | translate }}</strong>
              {{ 'FORM_RE_REGISTRATION.INFO.TEXT_1' | translate }}
            </p>
            <p class="final">
              {{ 'FORM_RE_REGISTRATION.INFO.TEXT_2' | translate }}
              <strong>{{ 'FORM_RE_REGISTRATION.INFO.BOLD_DATE' | translate }}</strong>
              {{ 'FORM_RE_REGISTRATION.INFO.TEXT_3' | translate }}
            </p>
          </app-lang-gate>
        </div>
        <div class="form-grid">
          <div class="top">
            <div class="country">
              <mat-label><app-lang-gate>
                <app-text-skeleton skeleton width="80px" />
                {{ 'FORM_RE_REGISTRATION.FIELDS.COUNTRY.LABEL' | translate }}
              </app-lang-gate></mat-label>
              <app-lang-gate>
                <app-text-skeleton skeleton height="40px" />
                <app-country-select
                  [country]="model().country"
                  (countryChange)="onCountryChange($event)"
                />
              </app-lang-gate>
            </div>

            <div class="phone">
              <mat-label><app-lang-gate>
                <app-text-skeleton skeleton width="80px" />
                {{ 'FORM_RE_REGISTRATION.FIELDS.CELLPHONE.LABEL' | translate }}
              </app-lang-gate></mat-label>
              <app-lang-gate>
                <app-text-skeleton skeleton height="40px" />
                <mat-form-field appearance="outline" class="full-width">
                  @if (phonePrefix()) {
                    <span matPrefix class="phone-prefix">{{ phonePrefix() }}&nbsp;</span>
                  }
                  <input
                    autocomplete="tel"
                    matInput
                    name="phone"
                    #phoneInput="ngModel"
                    [ngModel]="model().phone"
                    (ngModelChange)="updateField('phone', $event)"
                    [mask]="phoneMask()"
                    [placeholder]="phonePlaceholder()"
                    [dropSpecialCharacters]="true"
                    [required]="true"
                  />
                  @if (phoneInput.touched && phoneInput.errors?.['mask']) {
                    <mat-error>{{
                      'FORM_RE_REGISTRATION.FIELDS.CELLPHONE.ERROR_INVALID' | translate
                    }}</mat-error>
                  }
                </mat-form-field>
              </app-lang-gate>
            </div>
          </div>

          <div class="bottom">
              <div class="name">
                <mat-label><app-lang-gate>
                  <app-text-skeleton skeleton width="80px" />
                  {{ 'FORM_RE_REGISTRATION.FIELDS.NAME.LABEL' | translate }}
                </app-lang-gate></mat-label>
                <app-lang-gate>
                  <app-text-skeleton skeleton height="40px" />
                  <mat-form-field appearance="outline" class="full-width">
                    <input
                      autocomplete="name"
                      matInput
                      name="name"
                      [ngModel]="model().name"
                      (ngModelChange)="updateField('name', $event)"
                      [placeholder]="namePlaceholder()"
                      required
                    />
                  </mat-form-field>
                </app-lang-gate>
              </div>

            <div class="doc">
              <mat-label><app-lang-gate>
                <app-text-skeleton skeleton width="80px" />
                {{ documentType() || ('FORM_RE_REGISTRATION.FIELDS.DOCUMENT.LABEL' | translate) }}
              </app-lang-gate></mat-label>
              <app-lang-gate>
                <app-text-skeleton skeleton height="40px" />
                <mat-form-field appearance="outline" class="full-width">
                  <input
                    autocomplete="on"
                    matInput
                    name="document"
                    #documentInput="ngModel"
                    [ngModel]="model().document"
                    (ngModelChange)="updateField('document', $event)"
                    [mask]="documentMask()"
                    [placeholder]="documentPlaceholder()"
                    [dropSpecialCharacters]="true"
                    [required]="true"
                    [appDocumentValidator]="model().country"
                  />
                  @if (
                    documentInput.touched &&
                    (documentInput.errors?.['invalidDocument'] || documentInput.errors?.['mask'])
                  ) {
                    <mat-error>{{
                      'FORM_RE_REGISTRATION.FIELDS.DOCUMENT.ERROR_INVALID' | translate
                    }}</mat-error>
                  }
                </mat-form-field>
              </app-lang-gate>
            </div>
          </div>
        </div>

        <mat-label><app-lang-gate>
          <app-text-skeleton skeleton width="80px" />
          {{ 'FORM_RE_REGISTRATION.FIELDS.EMAIL.LABEL' | translate }}
        </app-lang-gate></mat-label>
        <app-lang-gate>
          <app-text-skeleton skeleton height="40px" />
          <mat-form-field
            appearance="outline"
            class="full-width"
            [class.email-invalid]="isEmailInUse()"
          >
            <input
              autocomplete="email"
              matInput
              type="email"
              name="email"
              [ngModel]="model().email"
              (ngModelChange)="updateField('email', $event)"
              [placeholder]="emailPlaceholder()"
              email
              required
              (focusout)="verifyEmail(model().email)"
              [attr.invalid]="isEmailInUse()"
            />
          </mat-form-field>
        </app-lang-gate>
        @if (isEmailInUse()) {
          <mat-error class="error-text" style="margin-left: -4px;">
            {{ 'FORM_RE_REGISTRATION.FIELDS.EMAIL.ERROR' | translate }}
          </mat-error>
        }

        @if (requestError()) {
          <mat-error class="error-text">
            {{ 'FORM_RE_REGISTRATION.ERROR_MESSAGE' | translate }}
          </mat-error>
        }
        <div class="warning-card">
          <app-lang-gate>
            <app-text-skeleton skeleton width="24px" height="24px" circle />
            <mat-icon fontSet="material-symbols-outlined">person_pin</mat-icon>
          </app-lang-gate>
          <p>
            <app-lang-gate>
              <app-text-skeleton skeleton />
              {{ 'FORM_RE_REGISTRATION.FIELDS.EMAIL.WARN' | translate }}
            </app-lang-gate>
          </p>
        </div>

        <mat-checkbox
          name="termsAccepted"
          [ngModel]="model().termsAccepted"
          (ngModelChange)="updateField('termsAccepted', $event)"
          [required]="true"
        >
          <p>
            <app-lang-gate>
              <app-text-skeleton skeleton width="260px" />
              {{ 'FORM_RE_REGISTRATION.FIELDS.DATA_TERMS.TEXT_1' | translate }}
              <strong>{{ 'FORM_RE_REGISTRATION.FIELDS.DATA_TERMS.BOLD' | translate }}</strong>
              {{ 'FORM_RE_REGISTRATION.FIELDS.DATA_TERMS.TEXT_2' | translate }}
            </app-lang-gate>
          </p>
        </mat-checkbox>
    </mat-card-content>

    <mat-card-actions class="actions">
      <button
        mat-stroked-button 
        color="warn" 
        type="button"
        (click)="goToGestaoFrotas()"
      >
        <app-lang-gate>
          <app-text-skeleton skeleton width="60px" />
          {{ 'FORM_RE_REGISTRATION.BUTTONS.CANCEL' | translate }}
        </app-lang-gate>
      </button>

      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="form.invalid || isEmailInUse() || isSendingOtp()"
      >
        <app-lang-gate>
          <app-text-skeleton skeleton width="60px" />
          {{ 'FORM_RE_REGISTRATION.BUTTONS.NEXT' | translate }}
        </app-lang-gate>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
